import styled from "@emotion/styled";
import { Button, FadeIn, FlexRow, H2, IconChevron, Stack } from "atoms";
import { formatDate } from "utils/date";
import { useToggle } from "utils/hooks";
import { OrderTag } from "./OrderTag";
import type { ShopOrder } from "../types";

type ShopOrderItemProps = {
  order: ShopOrder;
};
function ShopOrderItem({ order }: ShopOrderItemProps) {
  const [isOpen, toggleIsOpen] = useToggle(false);
  return (
    <OrderRow as="li" id={`${order.productId}-${order.fulfillmentLineItemId}`}>
      <Stack gap="xxs">
        <FlexRow gap="6px">
          <small>{formatDate(order.createdAt)}</small> <small>-</small>
          <small>From Order {order.orderNumber}</small>
        </FlexRow>
        <OrderItemGrid>
          <OrderTag status={order.status} />
          <FlexRow justifyContent="space-between" alignItems="flex-start">
            <H2 size="sm" textTransform="none" style={{ margin: 0 }}>
              {order.productTitle}
            </H2>
            <Button size="xxs" variant="text" onClick={toggleIsOpen}>
              <FlexRow gap="4px">
                <IconChevron rotate={isOpen ? 0 : 180} />
                <span>Details</span>
              </FlexRow>
            </Button>
          </FlexRow>
        </OrderItemGrid>
        <FadeIn
          hidden={!isOpen}
          style={{
            padding: 10,
            backgroundColor: "#efefef",
            borderRadius: 4,
            marginTop: 10,
          }}
        >
          <small>
            <pre>{JSON.stringify(order, null, 2)}</pre>
          </small>
        </FadeIn>
      </Stack>
    </OrderRow>
  );
}

const OrderRow = styled.div(({ theme }) => ({
  marginBottom: 20,
  paddingBottom: 20,
  borderBottom: "1px solid",
  borderBottomColor: theme.colors.fg20,
}));
const OrderItemGrid = styled.div({
  display: "grid",
  gridTemplateColumns: "auto 1fr",
  gap: 10,
});

// const DetailsGrid = styled.dl(({ theme }) => ({
//   display: "grid",
//   gridTemplateColumns: "1fr",
//   fontSize: 14,
//   gap: 0,

//   "dt,dd": {
//     margin: 0,
//   },
//   dt: {
//     borderTop: "1px solid",
//     borderTopColor: theme.colors.fg20,
//     paddingBlock: "8px 0",
//   },
//   dd: {
//     paddingBlock: "0 10px",
//   },
//   [theme.breakpoints.xs]: {
//     gridTemplateColumns: "minmax(150px, auto) 2fr",
//     dd: {
//       paddingLeft: theme.spacing.md,
//       borderTop: "1px solid",
//       borderTopColor: theme.colors.fg20,
//     },
//     "dt,dd": {
//       paddingBlock: "7px 5px",
//     },
//   },
// }));
export { ShopOrderItem, OrderItemGrid };
